import { useDrawers } from "@/hooks/useDrawers";
import { RFQDrawer } from "@/components/RFQDrawer";

export const DrawersManager = () => {
  const { rfqOpen, closeRFQ } = useDrawers();

  return (
    <>
      <RFQDrawer open={rfqOpen} onOpenChange={closeRFQ} />
    </>
  );
};